import React from 'react';

export default function ProfileModal({
    showModal,
    onClose,
    profileFormData,
    onInputChange,
    onSubmit,
    loading,
    error,
    success
}) {
    if (!showModal) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content appointment-details-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Edit Profile</h2>
                    <button className="modal-close" onClick={onClose} aria-label="Close modal">
                        ×
                    </button>
                </div>
                <div className="appointment-details-content" style={{ paddingBottom: '20px' }}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                            Email:
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={profileFormData.email}
                            onChange={onInputChange}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                            Username:
                        </label>
                        <input
                            type="text"
                            name="username"
                            value={profileFormData.username}
                            onChange={onInputChange}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                                First Name:
                            </label>
                            <input
                                type="text"
                                name="first_name"
                                value={profileFormData.first_name}
                                onChange={onInputChange}
                                style={{
                                    width: '100%',
                                    padding: '10px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #e2e8f0',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                                Last Name:
                            </label>
                            <input
                                type="text"
                                name="last_name"
                                value={profileFormData.last_name}
                                onChange={onInputChange}
                                style={{
                                    width: '100%',
                                    padding: '10px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #e2e8f0',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                            Phone Number:
                        </label>
                        <input
                            type="tel"
                            name="phone_number"
                            value={profileFormData.phone_number}
                            onChange={onInputChange}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                            Date of Birth:
                        </label>
                        <input
                            type="date"
                            name="date_of_birth"
                            value={profileFormData.date_of_birth}
                            onChange={onInputChange}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                            Address:
                        </label>
                        <textarea
                            name="address"
                            value={profileFormData.address || ''}
                            onChange={onInputChange}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box',
                                minHeight: '80px',
                                resize: 'vertical'
                            }}
                            placeholder="Enter your address"
                        />
                    </div>

                    {error && (
                        <div style={{
                            padding: '12px 14px',
                            backgroundColor: '#fee2e2',
                            color: '#dc2626',
                            borderRadius: '6px',
                            marginBottom: '16px',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    {success && (
                        <div style={{
                            padding: '12px 14px',
                            backgroundColor: '#dcfce7',
                            color: '#16a34a',
                            borderRadius: '6px',
                            marginBottom: '16px',
                            fontSize: '14px'
                        }}>
                            {success}
                        </div>
                    )}
                </div>
                <div className="modal-actions">
                    <button
                        type="button"
                        className="modal-button-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="modal-button-submit"
                        onClick={onSubmit}
                        disabled={loading}
                        style={{
                            opacity: loading ? 0.6 : 1,
                            cursor: loading ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
}
